import { cloneDeep } from 'lodash';
import { useMemo } from 'react';
import { useQuery, UseQueryResult } from 'react-query';
import { Filters } from '../../models';
import { IssuerListDto } from '../../services/dtos/issuer/issuerList.dto';
import { fetchIssuers } from '../../services/issuers/issuers.service';
import { IssuersQueryParams } from '../../services/issuers/issuersQueryParams';
import { deleteSourceAndContentType, getGroupedFilterTags } from '../../utils/filterUtils';
import { queryKeys } from '../queryKeyFactory';

export const RECENT_REC_CHANGES_BATCH_SIZE = 10;

export default (
  myCS: boolean,
  filters: Filters | null,
  watchlistId?: string,
  page = 0,
  take = RECENT_REC_CHANGES_BATCH_SIZE
): UseQueryResult<IssuerListDto, Error> => {
  const tags = useMemo(() => {
    if (!filters) {
      return undefined;
    }

    if (myCS) {
      return [];
    }

    const copy = cloneDeep(filters);

    if (!copy.tags) {
      return [];
    }

    deleteSourceAndContentType(copy);
    return getGroupedFilterTags(copy);
  }, [filters, myCS]);

  const queryParams: IssuersQueryParams = {
    myCS,
    tags,
    hasRecommendation: true,
    take,
    skip: page * take,
    sortField: 'latestRecommendation.changedDate',
    sortOrderAsc: false,
    watchlistId,
  };

  return useQuery<IssuerListDto, Error>(queryKeys.fetchIssuers.query(queryParams), () => fetchIssuers(queryParams), {
    enabled: !!tags,
  });
};
